import type { IUser } from './IUser'
import type { IAddress } from './IAddress'
import type { IFile } from './IFiles'
import type { CategoriesCompanyEnum } from './ICategories'
import type { CurrencyKey } from './ICurrency'
import type { IService } from './IService'
import type { IIntegration } from './IIntegration'
import type { Countries } from '@ui/components/input/phone/phoneUtils'
import type { ICompanyTariff, ISubscription } from './ISubscription'
import type { Merchant } from './MerchantType'

export const TimeFormat = {
  Hour12: '12Hour',
  Hour24: '24Hour',
}

type TimeFormatType = (typeof TimeFormat)[keyof typeof TimeFormat]

export type AutoPayoutMode = 'ORDER_DATE' | 'NEXT_DAY' | 'MANUAL'

export interface IEmailSettings {
  language: string
}

export interface ICompany {
  timezone?: string
  id?: number
  created?: Date | string
  _tariff?: ICompanyTariff
  userId?: number
  isTest?: boolean
  idAlias: string
  users?: IUser[]
  clientName: string
  clientDescription: string
  clientUrl: string
  rules?: string
  privacyPolicy?: string
  personalDataConsent?: string
  marketingConsent?: string
  calendarTimeStep: number
  inn: string
  meta: {
    phone: string
    email: string
    category: CategoriesCompanyEnum
  }
  // & typeof Fields.phoneObjectTemplate,
  addresses: IAddress[]
  services: IService[]
  isEnable: boolean
  files?: IFile[]
  logoUrl?: string
  currency: CurrencyKey
  emailSettings?: IEmailSettings
  settings?: {
    phoneCountryCode: Countries
    slotPriceVisibility: boolean
    timeFormat: TimeFormatType
    autoPayoutMode?: AutoPayoutMode
    allowOrderCompletionWithoutFullPayment?: boolean
  }
  clientIntegrations?: IIntegration[]
  subscriptions?: ISubscription[]
  merchantData?: Merchant | null
  merchantDataId?: number | null
  stripeAccount?: {
    id: string
    isActive: boolean
  }
  stripeAccountId?: string | null
  paymentLinkSeconds?: number | null
  nearBookingPaymentLinkEnabled?: boolean | null
  nearBookingThresholdSeconds?: number | null
  nearBookingPaymentLinkSeconds?: number | null
}
